import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  n: '01',
  title: 'ATLAS VISUAL DEL IREZUMI CLÁSICO',
  desc: 'Ukiyo-e • Edo • Kabuki • Tradición',
  image: 'https://cdn.magicpatterns.com/uploads/3uDdq2414s7iUtSWrZZGrq/bonus_1.png'
}, {
  n: '02',
  title: 'DICCIONARIO VISUAL DEL IREZUMI',
  desc: 'Símbolos • Energía • Simbolismo',
  image: 'https://cdn.magicpatterns.com/uploads/irDBZDJFkxUUbES1uTFcav/bonus_2.png'
}, {
  n: '03',
  title: 'PERSONAJES LEGENDARIOS DEL JAPÓN',
  desc: 'Guerreros • Héroes • Leyendas',
  image: 'https://cdn.magicpatterns.com/uploads/wF5SzKcDNYEfSutK35d6eu/bonus_3.png'
}, {
  n: '04',
  title: 'CRIATURAS Y MITOLOGÍA JAPONESA',
  desc: 'Yokai • Espíritus • Dioses',
  image: 'https://cdn.magicpatterns.com/uploads/9JMzYWCXhmArqzu8k6FjZu/bonus_4.png'
}, {
  n: '05',
  title: 'EL CÓDIGO DEL SAMURÁI',
  desc: 'Bushido • Honor • Disciplina',
  image: 'https://cdn.magicpatterns.com/uploads/agNt8bziqRoKE88cbTvHQG/bonus_5.png'
}, {
  n: '06',
  title: 'ATLAS VISUAL DE TATUAJES REALES DEL MUNDO IREZUMI',
  desc: 'Composiciones • Referencias • Artistas',
  image: 'https://cdn.magicpatterns.com/uploads/ofNrpwmfV9k9GTM13BX9xq/bonus_premium.png',
  premium: true
}];
export function BonusSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-21">
            <span className="text-xs font-bold tracking-widest" data-id="element-22">
              🎁 6 BONUS INCLUIDOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-23">
            Y además recibís toda la{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-24">
              colección complementaria
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-5" data-id="element-25">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} whileHover={{
          y: -4
        }} className={`relative bg-bg-soft border rounded-3xl p-5 shadow-sm hover:shadow-xl hover:shadow-rose/10 transition-all flex flex-col ${b.premium ? 'border-rose/40 ring-1 ring-rose/20' : 'border-line'}`} data-id="element-26">
              {b.premium && <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-27">
                  <span className="bg-ink text-rose text-[10px] font-black tracking-widest px-3 py-1.5 rounded-full border border-rose/50 shadow-md whitespace-nowrap" data-id="element-28">
                    ⭐ BONUS PREMIUM
                  </span>
                </div>}
              <div className="relative aspect-[4/5] rounded-2xl mb-5 flex items-center justify-center overflow-hidden" style={{
            background: 'radial-gradient(ellipse at center, rgba(216,105,54,0.18), rgba(0,0,0,0.4) 70%), linear-gradient(180deg, #1A1B20 0%, #0F1014 100%)'
          }} data-id="element-29">
                {/* Soft shadow under book */}
                <div className="absolute bottom-[12%] left-1/2 -translate-x-1/2 w-[60%] h-3 bg-black/60 blur-xl rounded-full" data-id="element-30" />
                <img src={b.image} alt={b.title} className="relative z-10 max-h-[88%] max-w-[80%] w-auto h-auto object-contain drop-shadow-2xl" data-id="element-31" />
              </div>
              <div className="px-1 pb-1 flex-1 flex flex-col" data-id="element-32">
                <div className="text-[11px] font-bold text-rose tracking-widest mb-2" data-id="element-33">
                  🎁 BONO {b.n}
                </div>
                <h3 className="font-serif font-bold text-base md:text-lg text-ink leading-snug uppercase mb-2" data-id="element-34">
                  {b.title}
                </h3>
                <p className="text-ink-soft text-sm leading-relaxed" data-id="element-35">
                  {b.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-10" data-id="element-36">
          <p className="font-serif-italic text-rose text-lg md:text-2xl" data-id="element-37">
            Valor incalculable en referencias visuales →{' '}
            <strong className="not-italic text-ink font-serif font-bold" data-id="element-38">
              GRATIS
            </strong>{' '}
            con tu colección
          </p>
        </motion.div>
      </div>
    </section>;
}